// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1533":"7f7df6f5cdaf99b6","9484":"84a6033e3402898d"}[chunkId] + ".css";
};